import * as React from "react";
import { forwardRef } from "react";
const SvgShield = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.37 15.96A11.41 11.41 0 0 1 .001 5.06a2 2 0 0 1 1.105-1.788l6-3a2 2 0 0 1 1.79 0l6 3a2 2 0 0 1 1.105 1.789 11.41 11.41 0 0 1-7.368 10.9c-.41.138-.854.138-1.265 0M2.001 5.06a9.39 9.39 0 0 0 6 9 9.39 9.39 0 0 0 6-9l-6-3zm4.293 5.709-2-2A1 1 0 0 1 5.71 7.354l1.293 1.293 3.292-3.293a.999.999 0 1 1 1.415 1.414l-4 4a1 1 0 0 1-1.414 0" }));
const ForwardRef = forwardRef(SvgShield);
export { ForwardRef as ReactComponent };
